module.exports = __webpack_public_path__ + "static/media/whatsapp3.580ca92b.png";